import React, { useEffect, useState } from "react";
import { currencies } from "currencies.json";
import Select from "react-select";
import { withAuthentication } from "@/hoc/withAuthentication";
import { getActiveShop } from "@/constants/utility";

const Currency = ({ user, httpClient }) => {
  const selectedShop = getActiveShop(user) || {};

  const options = currencies.map(({ code: label, symbol: value }) => {
    return { label, value };
  });

  const [selectedCurrency, setSelectedCurrency] = useState(() =>
    options.find((v) => {
      return v.value === (selectedShop.currencyPortal || "$");
    })
  );

  const updateCurrency = (currency, code) => {
    user.updateShop({ ...selectedShop, currencyPortal: currency, currencyCode: code });

    httpClient
      .put(`/repairshop/currencysymbol/${selectedShop._id}`, {
        currency,
        code,
      })
      .catch((err) => {});
  };
  const currencyCode = selectedShop.currencyCode ? selectedShop.currencyCode : selectedCurrency.label

  return (
    <React.Fragment>
      <a className="uk-text-capitalize uk-text-bold" type="button">
        {currencyCode}{" "} 
        <span uk-icon="icon: chevron-down; ratio: 1"></span>
      </a>

      <div uk-dropdown="mode: click;" className="">
        <Select
          name="id"
          options={options}
          onChange={(evt) => {
            setSelectedCurrency(evt);
            updateCurrency(evt.value, evt.label);
          }}
          defaultValue={selectedCurrency}
        />
      </div>
    </React.Fragment>
  );
};

export default withAuthentication(Currency);
